import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem
} from '@material-ui/core'

import toastError from '../../errors/toastError'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import SelectInput from '../SelectInput'; // Importe o componente SelectInput
import { useStyles } from './style'

const PrivacyModal = ({ open, onClose, whatsAppId }) => {
  const classes = useStyles()

  const initialState = {
    readreceipts: 'all',
    profile: 'all',
    status: 'all',
    online: 'all',
    last: 'all',
    groupadd: 'all',
    calladd: 'all',
    disappearing: '0'
  }
  const [privacy, setPrivacy] = useState(initialState)

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return

      try {
        const { data } = await api.get(`whatsapp/privacy/${whatsAppId}`)
        setPrivacy(data)
      } catch (err) {
        toastError(err)
      }
    }
    fetchSession()
  }, [whatsAppId])

  const handleSavePrivacy = async values => {
    const privacyData = { ...values }

    try {
      await api.put(`/whatsapp/privacy/${whatsAppId}`, privacyData)
      toast.success(i18n.t('privacyModal.success'))
      handleClose()
    } catch (err) {
      toastError(err)
    }
  }

  const handleClose = () => {
    onClose()
    setPrivacy(initialState)
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        // fullWidth
        scroll="paper"
      >
        <DialogTitle className={classes.dialogTitle}>
          {i18n.t('privacyModal.title')}
          {privacy.whatsapp && <>- {privacy?.whatsapp?.name}</>}
        </DialogTitle>
        <Formik
          initialValues={privacy}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSavePrivacy(values)
              actions.setSubmitting(false)
            }, 400)
          }}
        >
          {({ values, setFieldValue, touched, errors, isSubmitting }) => (
            <Form>
              <DialogContent dividers>
                <div className={classes.multFieldLine}>
                  <Grid spacing={2} container>
                    <Grid xs={6} md={6} item>
                      <SelectInput
                        id="readreceipts-selection-label"
                        name="readreceipts"
                        label={i18n.t('privacyModal.form.readreceipts')}
                        value={values.readreceipts}
                        onChange={e =>
                          setFieldValue('readreceipts', e.target.value)
                        }
                        error={touched.readreceipts && !!errors.readreceipts}
                        helperText={touched.readreceipts && errors.readreceipts}
                      >
                        <MenuItem value="all">
                          {i18n.t('privacyModal.form.menu.all')}
                        </MenuItem>
                        <MenuItem value="none">
                          {i18n.t('privacyModal.form.menu.none')}
                        </MenuItem>
                      </SelectInput>
                    </Grid>

                    <Grid xs={6} md={6} item>
                      <SelectInput
                        id="profile-selection-label"
                        name="profile"
                        label={i18n.t('privacyModal.form.profile')}
                        value={values.profile}
                        onChange={e => setFieldValue('profile', e.target.value)}
                        error={touched.profile && !!errors.profile}
                        helperText={touched.profile && errors.profile}
                      >
                        <MenuItem value="all">
                          {i18n.t('privacyModal.form.menu.all')}
                        </MenuItem>
                        <MenuItem value="contacts">
                          {i18n.t('privacyModal.form.menu.contacts')}
                        </MenuItem>
                        <MenuItem value="contact_blacklist">
                          {i18n.t('privacyModal.form.menu.contact_blacklist')}
                        </MenuItem>
                        <MenuItem value="none">
                          {i18n.t('privacyModal.form.menu.none')}
                        </MenuItem>
                      </SelectInput>
                    </Grid>

                    <Grid xs={6} md={6} item>
                      <SelectInput
                        id="status-selection-label"
                        name="status"
                        label={i18n.t('privacyModal.form.status')}
                        value={values.status}
                        onChange={e => setFieldValue('status', e.target.value)}
                        error={touched.status && !!errors.status}
                        helperText={touched.status && errors.status}
                      >
                        <MenuItem value="all">
                          {i18n.t('privacyModal.form.menu.all')}
                        </MenuItem>
                        <MenuItem value="contacts">
                          {i18n.t('privacyModal.form.menu.contacts')}
                        </MenuItem>
                        <MenuItem value="contact_blacklist">
                          {i18n.t('privacyModal.form.menu.contact_blacklist')}
                        </MenuItem>
                        <MenuItem value="none">
                          {i18n.t('privacyModal.form.menu.none')}
                        </MenuItem>
                      </SelectInput>
                    </Grid>

                    <Grid xs={6} md={6} item>
                      <SelectInput
                        id="calladd-selection-label"
                        name="calladd"
                        label={i18n.t('privacyModal.form.calladd')}
                        value={values.calladd}
                        onChange={e => setFieldValue('calladd', e.target.value)}
                        error={touched.calladd && !!errors.calladd}
                        helperText={touched.calladd && errors.calladd}
                      >
                        <MenuItem value="all">
                          {i18n.t('privacyModal.form.menu.all')}
                        </MenuItem>
                        <MenuItem value="known">
                          {i18n.t('privacyModal.form.menu.known')}
                        </MenuItem>
                      </SelectInput>
                    </Grid>

                    <Grid xs={6} md={6} item>
                      <SelectInput
                        id="last-selection-label"
                        name="last"
                        label={i18n.t('privacyModal.form.last')}
                        value={values.last}
                        onChange={e => setFieldValue('last', e.target.value)}
                        error={touched.last && !!errors.last}
                        helperText={touched.last && errors.last}
                      >
                        <MenuItem value="all">
                          {i18n.t('privacyModal.form.menu.all')}
                        </MenuItem>
                        <MenuItem value="contacts">
                          {i18n.t('privacyModal.form.menu.contacts')}
                        </MenuItem>
                        <MenuItem value="contact_blacklist">
                          {i18n.t('privacyModal.form.menu.contact_blacklist')}
                        </MenuItem>
                        <MenuItem value="none">
                          {i18n.t('privacyModal.form.menu.none')}
                        </MenuItem>
                      </SelectInput>
                    </Grid>

                    <Grid xs={6} md={6} item>
                      <SelectInput
                        id="groupadd-selection-label"
                        name="groupadd"
                        label={i18n.t('privacyModal.form.groupadd')}
                        value={values.groupadd}
                        onChange={e =>
                          setFieldValue('groupadd', e.target.value)
                        }
                        error={touched.groupadd && !!errors.groupadd}
                        helperText={touched.groupadd && errors.groupadd}
                      >
                        <MenuItem value="all">
                          {i18n.t('privacyModal.form.menu.all')}
                        </MenuItem>
                        <MenuItem value="contacts">
                          {i18n.t('privacyModal.form.menu.contacts')}
                        </MenuItem>
                        <MenuItem value="contact_blacklist">
                          {i18n.t('privacyModal.form.menu.contact_blacklist')}
                        </MenuItem>
                      </SelectInput>
                    </Grid>

                    {/*<Grid xs={6} md={6} item>
                      <SelectInput
                        id="disappearing-selection-label"
                        name="disappearing"
                        label={i18n.t("privacyModal.form.disappearing")}
                        value={values.disappearing}
                        onChange={(e) => setFieldValue('disappearing', e.target.value)}
                        error={touched.disappearing && !!errors.disappearing}
                        helperText={touched.disappearing && errors.disappearing}
                      >
                        <MenuItem value="0">
                          {i18n.t("privacyModal.form.menu.disable")}
                        </MenuItem>
                        <MenuItem value="86400">
                          {i18n.t("privacyModal.form.menu.hrs24")}
                        </MenuItem>
                        <MenuItem value="604800">
                          {i18n.t("privacyModal.form.menu.dias7")}
                        </MenuItem>
                        <MenuItem value="7776000">
                          {i18n.t("privacyModal.form.menu.dias90")}
                        </MenuItem>
                      </SelectInput>
                    </Grid>*/}

                    <Grid xs={12} md={12} item>
                      <SelectInput
                        id="online-selection-label"
                        name="online"
                        label={i18n.t('privacyModal.form.online')}
                        value={values.online}
                        onChange={e => setFieldValue('online', e.target.value)}
                        error={touched.online && !!errors.online}
                        helperText={touched.online && errors.online}
                      >
                        <MenuItem value="all">
                          {i18n.t('privacyModal.form.menu.all')}
                        </MenuItem>
                        <MenuItem value="match_last_seen">
                          {i18n.t('privacyModal.form.menu.match_last_seen')}
                        </MenuItem>
                      </SelectInput>
                    </Grid>
                  </Grid>
                </div>
              </DialogContent>
              <DialogActions>
                <ButtonSecondary
                  onClick={handleClose}
                  disabled={isSubmitting}
                  label={i18n.t('privacyModal.buttons.cancel')}
                />

                <ButtonPrimary
                  type="submit"
                  disabled={isSubmitting}
                  className={classes.btnWrapper}
                  label={i18n.t('privacyModal.buttons.okEdit')}
                />
                {/* {i18n.t('privacyModal.buttons.okEdit')}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )} */}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  )
}

export default React.memo(PrivacyModal)
